import { setWalkeMeProfile } from './hooks';

export const useUserService = () => {
    return setWalkeMeProfile;
};
